<template>
  <div>
    <form id="payment-form">
      <div id="payment-element"></div>
      <button ref="stripeSubmit" style="display:none;"></button>
    </form>
  </div>
</template>

<script lang="js">
import { loadStripe } from '@stripe/stripe-js';

export default {
  name: 'StripePaymentForm',
  components: {},
  props:{
    intents: 0,
    paymentData: {}
  },  
  data() {
    return {
      stripe: {},
      clientSecret: null,
      paymentIntent: null,
      paymentIntentId: null,
      paymentElement: 'payment-element',
      draft: 'requires_payment_method',
      order: {
        amount: 0,
        currency: ''
      }
    }
  },
  async created() {
    const stripePK = document.querySelector('body').dataset.stripePublicKey;
    this.order = this.paymentData;

    this.stripe = await loadStripe(stripePK);
    await this.createPaymentIntent();
  },
  methods: {
    async createPaymentIntent() {      
      try {
        const response = await this.$http.post('/api/v2/orders/stripe_secret', this.order);
        this.paymentIntent = response.data;
        this.paymentIntentId = response.data.id;
        this.clientSecret = response.data.client_secret;
        this.renderForm();
      } catch (e) {
        this.$alertify.error('Error: ' + e.message);
      }
    },

    async updatePaymentIntent() {
      if (this.isDraft) {
        try {
          const response = await this.$http.post('/api/v2/orders/stripe_update_intent', {
            ...this.order,
            id: this.paymentIntentId
          });
          this.paymentIntent = response.data;
        } catch (e) {
          this.$alertify.error('Error: ' + e.message);
        }        
      }
    },

    renderForm() {
      const elements = this.stripe.elements(this.paymentOptions);
      elements.create('payment').mount(this.paymentElementId);
        
      const form = document.getElementById('payment-form');

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const { error } = await this.stripe.confirmPayment({
          elements,
          redirect: 'if_required'
        });

        if (error) {
          this.$emit('onFail', error.message);
        } else {
          await this.getPayment();
        }
      });
    },

    async getPayment() {
      const { paymentIntent } = await this.stripe.retrievePaymentIntent(this.clientSecret);
      this.$emit('setPaymentIntentId', paymentIntent.id);

      /*
      switch (paymentIntent.status) {
        case 'succeeded':
          this.$alertify.success('Success! Payment received.');
          break;

        case 'processing':
          this.$alertify.success('Payment processing. We will update you when payment is received.');
          break;

        case 'requires_payment_method':
          this.$alertify.error('Payment failed. Please try another payment method.');
          // Redirect your user back to your payment page to attempt collecting
          // payment again
          break;

        default:
          this.$alertify.error('Something went wrong.');
          break;
      }
      */
    }

  },
  computed: {
    paymentElementId() {
      return `#${this.paymentElement}`;
    },

    paymentOptions() {
      return {
        clientSecret: this.clientSecret,
        appearance: {}
      };
    },

    isDraft() { 
      return (this.paymentIntent && this.paymentIntent.status == this.draft);
    }
  },
  watch: {
    intents(newVal) {
      if (newVal > 0) { 
        this.$refs.stripeSubmit.click();
      }
    },
    async paymentData(newVal) {
      this.order = newVal;
      await this.updatePaymentIntent();
    },
  }
}
</script>